
import  React from "react"
import { Modal, Button, List, Spin } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import PropTypes from "prop-types" // Import PropTypes
import { useEffect, useState } from "react"
import BillHistoryModal from "./Bill-history-modal"
import BillingHistoryModal from "./BillHistory"
import CreateBillModal from "./Itemized-bill-modal";
import { getBills } from '../../services/doctor/bills/bills';
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const BillPaymentModal = ({isOpen, onClose, patientData, onCreateNewBill}) => {

  /*const recentBills = [
    {
      id: "SRH/2025-2026/1000006",
      date: "29/04/2025",
      amount: "₹50",
      due: "₹250",
    },
    {
      id: "SRH/2025-2026/1000005",
      date: "29/04/2025",
      amount: "₹800",
      due: "",
    },
  ]*/
  const [isBillHistoryOpen, setIsBillHistoryOpen] = useState(false);
  const [isCreateBillOpen, setIsCreateBillOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [recentBills, setRecentBills] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [editBillData, setEditBillData] = useState("");

  const fetchRecentBills = async () => {
    try {
      setLoading(true);
      const result = await getBills(searchKeyword, '', patientData?.id, 3);
      if (result.success) {
        console.log('Recent Bills data:', result.data);
        setRecentBills(result.data);
        setLoading(false);
      } else {
        // Optionally handle error
        setRecentBills([]);
      }
    } catch (err) {
      // Optionally handle error
      setRecentBills([]);
    }
  };
    
  useEffect(()=>{
    if( isOpen )
    {
      fetchRecentBills();
    }
  },[isOpen, refresh]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#1890ff",
              margin: "-20px -24px 20px",
              padding: "10px 24px",
              color: "white",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Bill / Payment</span>
            </div>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ color: "white" }} />
          </div>
        }
        open={isOpen}
        onCancel={onClose}
        maskClosable={false} 
          keyboard={false}
        footer={null}
        width={600}
        styles={{ padding: "0 24px 24px" }}
        closable={false}
        centered
      >
        {loading ? (
          <div className="w-100 p-4 d-flex align-items-center justify-content-center">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
              <h3>Recently Created Bills</h3>
              <Button type="primary" onClick={() => { setIsCreateBillOpen(true), setisEdit(false), setEditBillData("") }} style={{ borderRadius: "4px" }}>
                Create New Bill
              </Button>
            </div>
            
            <List
              dataSource={recentBills}
              renderItem={(item, index) => (
                <List.Item
                  style={{
                    padding: "10px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>
                        {index + 1}. 
                          <Link to="#" onClick={()=>{ setIsCreateBillOpen(true), setisEdit(true), setEditBillData(item) }}>{item.doctor_bill_no}</Link> on {dayjs(item.created_at).format("DD MMM YYYY")}
                      </div>
                      <div style={{ fontWeight: "bold" }}>₹{item.payment_amount}</div>
                    </div>
                  </div>
                </List.Item>
              )}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
              <Button
                type="primary"
                style={{
                  background: "white",
                  color: "#1890ff",
                  borderColor: "#1890ff",
                  borderRadius: "4px",
                }}
                onClick={() => setIsBillHistoryOpen(true)}
              >
                View Billing History
              </Button>
            </div>
          </>
        )}
        
      </Modal>

      <BillingHistoryModal patientData={patientData} visible={isBillHistoryOpen} onClose={() => setIsBillHistoryOpen(false)} />

      <CreateBillModal patientData={patientData} isOpen={isCreateBillOpen} onClose={() => setIsCreateBillOpen(false)} refresh={() => setRefresh(!refresh)} isedit={isEdit} editBillData={editBillData} />
    </>
  )
}
BillPaymentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired, // isOpen must be a boolean and is required
    onClose: PropTypes.func.isRequired, // onClose must be a function and is required
    patientData: PropTypes.patientData,
    onCreateNewBill: PropTypes.func.isRequired, // onCreateNewBill must be a function and is required
  }

export default BillPaymentModal
